/**
 * The generated `Citation` (OpenAPI, nullable location keys) → the shared UI
 * `Citation` (absent keys). Same contract, different spelling of "not set".
 */

import type { Citation, CitationLocation } from "@/features/solutions/shared";
import type { components } from "@/shared/api/_generated/schema";

type ApiCitation = components["schemas"]["Citation"];

function pair(value: number[] | null | undefined): [number, number] | undefined {
  return value && value.length === 2 ? [value[0] ?? 0, value[1] ?? 0] : undefined;
}

export function toCitation(c: ApiCitation): Citation {
  const loc = c.location;
  const location: CitationLocation = {};
  if (typeof loc.page === "number") location.page = loc.page;
  if (loc.pages) location.pages = loc.pages;
  if (loc.sheet) location.sheet = loc.sheet;
  const rows = pair(loc.rows);
  if (rows) location.rows = rows;
  const lines = pair(loc.lines);
  if (lines) location.lines = lines;
  return {
    n: c.n,
    chunk_id: c.chunk_id,
    index_id: c.index_id,
    document_id: c.document_id,
    display_name: c.display_name,
    location,
    snippet: c.snippet,
    content_url: c.content_url,
  };
}
